import { isNotificationUnread } from '@/utils/notification_display'

function ensureArray(notifications) {
  return Array.isArray(notifications) ? notifications : []
}

function isNumber(value) {
  return typeof value === 'number' && Number.isFinite(value)
}

export function countUnreadNotifications(notifications = []) {
  return ensureArray(notifications).filter((notification) =>
    isNotificationUnread(notification)
  ).length
}

export function computeNotificationCounts(notifications = [], meta = {}) {
  const list = ensureArray(notifications)
  const fallbackUnread = countUnreadNotifications(list)
  const unread = isNumber(meta?.unread_count)
    ? meta.unread_count
    : fallbackUnread
  const totalFallback = Math.max(list.length, fallbackUnread)
  const total = isNumber(meta?.total_count) ? meta.total_count : totalFallback
  return { unread, total }
}

export function mergeNotificationMeta(notifications = [], meta = {}) {
  const { unread, total } = computeNotificationCounts(notifications, meta)
  return {
    ...meta,
    unread_count: unread,
    total_count: total
  }
}
